import { PulseEnvironment } from '../../globals';

export class DataLayerService {
    constructor(private env: PulseEnvironment) {}
    pushData(data: any): void {
        if (!this.env.win.dataLayer) {
            this.env.win.dataLayer = [];
        }
        this.env.win.dataLayer.push(data);
    }
}
